import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fileSize',
    standalone: true
})
export class FileSizePipe implements PipeTransform {
  transform(value: number): string {
    if (value < Math.pow(10, 3)) return value + ' o';
    else if (value < Math.pow(10, 6)) return (value / Math.pow(10, 3)).toFixed(0) + ' ko';
    else if (value < Math.pow(10, 9)) return (value / Math.pow(10, 6)).toFixed(1) + ' Mo';
    else return (value / Math.pow(10, 9)).toFixed(2) + ' Go';
  }
}
